import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";
import { ReactNode } from "react";

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  useIsAuthenticated();

  return <>{children}</>;
};
